import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { AlertTriangle, XCircle } from 'lucide-react';
export function ProblemSection() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <Section id="problem" background="darker" className="border-t border-slate-900" data-id="element-194">
      <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-100px'
    }} className="max-w-3xl mx-auto" data-id="element-195">
        <div className="flex items-center gap-3 mb-6" data-id="element-196">
          <AlertTriangle className="text-brand-orange w-6 h-6" data-id="element-197" />
          <span className="text-brand-orange font-bold uppercase tracking-widest text-sm" data-id="element-198">
            The "Adult HIIT" Trap
          </span>
        </div>

        <motion.h2 variants={item} className="text-3xl md:text-5xl font-heading font-bold text-white mb-8 leading-tight" data-id="element-199">
          "Pushing Through The Pain" Is The Fastest Way To A{' '}
          <span className="text-red-500" data-id="element-200">Surgical Consult</span>.
        </motion.h2>

        <motion.div variants={item} className="prose prose-lg prose-invert text-slate-300 mb-12" data-id="element-201">
          <p className="lead text-xl text-slate-200 font-medium" data-id="element-202">
            It starts with a dull ache after a morning walk. Then, a sharp
            'twinge' when you stand up from a chair.
          </p>
          <p data-id="element-203">
            You know the weight is creeping up. You see it in the mirror, and
            you feel it in your energy levels. But every time you try to 'get
            back into it,' your body revolts. Your knees throb. Your lower back
            screams.
          </p>
          <p data-id="element-204">
            You’ve been told that to lose weight, you have to "sweat it out" and
            "push through the pain."
          </p>
          <p className="text-white font-bold text-xl border-l-4 border-brand-orange pl-4 italic" data-id="element-205">
            That is a lie.
          </p>
          <p data-id="element-206">
            Modern fitness apps are designed for 20-year-old elasticity. When a
            50+ body does those movements, the force goes into the joint, not
            the muscle. This triggers systemic inflammation, which actually{' '}
            <span className="text-white underline decoration-brand-orange/50 decoration-2 underline-offset-4" data-id="element-207">
              stalls your weight loss
            </span>
            .
          </p>
        </motion.div>

        <motion.div variants={item} className="bg-slate-900 border border-slate-800 p-8 rounded-lg" data-id="element-208">
          <h3 className="text-xl font-heading font-bold text-white mb-6 uppercase" data-id="element-209">
            Why Generic Workouts Fail Men Over 50
          </h3>
          <div className="space-y-4" data-id="element-210">
            {[{
            title: 'High Impact',
            desc: "Burpees and box jumps destroy meniscus cartilage that doesn't grow back."
          }, {
            title: 'Volume Overload',
            desc: "Doing 'more reps' just increases wear and tear without building real strength."
          }, {
            title: 'Inflammation Spike',
            desc: 'Hard cardio raises cortisol, signaling your body to store belly fat.'
          }].map((point, i) => <div key={i} className="flex gap-4 items-start" data-id="element-211">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-212" />
                <div data-id="element-213">
                  <h4 className="text-white font-bold" data-id="element-214">{point.title}</h4>
                  <p className="text-slate-400 text-sm" data-id="element-215">{point.desc}</p>
                </div>
              </div>)}
          </div>
        </motion.div>
      </motion.div>
    </Section>;
}